// extracted by css-extract-rspack-plugin
export default {"csvFilter":"CSVBlob-module__csvFilter__USISf","csvTable":"CSVBlob-module__csvTable__IF6xK"};